const AI_ACT_CELEX = '32024R1689';
const EUR_LEX_LANGUAGES: Readonly<Record<string, string>> = { it: 'IT', es: 'ES', ro: 'RO' };
const EUR_LEX_FALLBACK_LANGUAGE = 'EN';

/** Le lingue della UI fuori dall'UE (uk, bn, zh, ar) non hanno una versione EUR-Lex ufficiale: si ripiega sull'inglese. */
export function aiActUrl(uiLanguage: string): string {
  const baseLanguage = uiLanguage.toLowerCase().split('-')[0];
  const eurLexLanguage = EUR_LEX_LANGUAGES[baseLanguage] ?? EUR_LEX_FALLBACK_LANGUAGE;
  return `https://eur-lex.europa.eu/legal-content/${eurLexLanguage}/TXT/?uri=CELEX:${AI_ACT_CELEX}`;
}
